var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_c('div',[_c('AppDrawer')],1),_c('div',{staticClass:"main--content"},[_c('AppHeader',{staticClass:"container--fluid"}),_c('MobileHeader'),_c('router-view',{staticClass:"container--fluid"})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }